import React, { useEffect, useRef, useCallback, useState } from 'react'

import Popup from './index'

interface TruncatedProps {
  content: string
  popupContent?: React.ReactNode
  className?: string
  children?: React.ReactNode
}

const Truncated: React.FC<TruncatedProps> = ({ content, popupContent, className, children }) => {
  const textRef = useRef<HTMLDivElement | null>(null)
  const wrapperRef = useRef<HTMLDivElement>(null)
  const [isTruncated, setIsTruncated] = useState(false)
  const [open, setOpen] = useState(false)

  const hasChildren = children != null

  const checkTruncation = useCallback(() => {
    const element = hasChildren
      ? (wrapperRef.current?.firstElementChild as HTMLElement)
      : textRef.current
    if (!element) {
      return
    }

    setIsTruncated(element.scrollWidth > element.offsetWidth)
  }, [hasChildren])

  useEffect(() => {
    const element = hasChildren
      ? (wrapperRef.current?.firstElementChild as HTMLElement)
      : textRef.current
    if (!element) {
      return
    }

    const observer = new ResizeObserver(checkTruncation)
    observer.observe(element)

    return () => observer.disconnect()
  }, [checkTruncation, hasChildren])

  useEffect(() => {
    checkTruncation()
  }, [content, checkTruncation])

  useEffect(() => {
    if (!isTruncated) {
      setOpen(false)
    }
  }, [isTruncated])

  const trigger = hasChildren ? (
    <div ref={wrapperRef}>{children}</div>
  ) : (
    <div ref={textRef} className={`truncate ${className ?? ''}`}>
      {content}
    </div>
  )

  return (
    <Popup
      size="mini"
      position="top left"
      flowing={false}
      open={isTruncated && open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      tooltip={popupContent ?? content}
    >
      {trigger}
    </Popup>
  )
}

export default Truncated



// WEBPACK FOOTER //
// ./src/shared/components/Popup/Truncated.tsx